<template>
    <div>
        <div class="card-info remains-manager">
            <div>
                <strong class="title">Остатки</strong>
                <ul class="remains-list">
                    <li v-for="(remain, index) in remainsSorted" :key="index" class="remain-row" style="list-style: none">
                        <span class="warehouse-title">{{ remain.warehouse.title }}:</span> <span> {{ remain.quantity }} </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        remains:{
            required: true
        }
    },
    computed: {
        remainsSorted: function() {
            let remains = [];
            this.remains.forEach(remain => {
                Object.assign(remain, {
                    sorting: remain.warehouse.sorting
                });
                remains.push(remain)
            });
            return _.orderBy(remains, 'sorting', 'asc');
        }
    }
}
</script>
